import { render, staticRenderFns } from "./StaticCard.vue?vue&type=template&id=b3367478&scoped=true&"
import script from "./StaticCard.vue?vue&type=script&lang=js&"
export * from "./StaticCard.vue?vue&type=script&lang=js&"
import style0 from "./StaticCard.vue?vue&type=style&index=0&id=b3367478&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3367478",
  null
  
)

export default component.exports